import React from 'react'

const hdpeMatrixData = [
	{
		minOd: 20,
		maxOd: '20.20',
		pn16: ['2.30', '2.60'],
		pn12_5: ['2.00', '2.20'],
		pn10: [null, null],
		pn8: [null, null],
		pn6: [null, null],
	},
	{
		minOd: 25,
		maxOd: '25.20',
		pn16: ['2.30', '2.60'],
		pn12_5: ['2.00', '2.20'],
		pn10: [null, null],
		pn8: [null, null],
		pn6: [null, null],
	},
	{
		minOd: 32,
		maxOd: '32.20',
		pn16: ['3.00', '3.30'],
		pn12_5: ['2.50', '2.80'],
		pn10: [null, null],
		pn8: [null, null],
		pn6: [null, null],
	},
	{
		minOd: 40,
		maxOd: '40.30',
		pn16: ['3.70', '4.00'],
		pn12_5: ['3.00', '3.40'],
		pn10: [null, null],
		pn8: [null, null],
		pn6: [null, null],
	},
	{
		minOd: 50,
		maxOd: '50.30',
		pn16: ['4.60', '4.90'],
		pn12_5: ['3.70', '4.00'],
		pn10: ['3.00', '3.30'],
		pn8: [null, null],
		pn6: [null, null],
	},
	{
		minOd: 63,
		maxOd: '63.30',
		pn16: ['5.80', '6.10'],
		pn12_5: ['4.70', '5.00'],
		pn10: ['3.70', '4.00'],
		pn8: [null, null],
		pn6: [null, null],
	},
	{
		minOd: 75,
		maxOd: '75.30',
		pn16: ['6.80', '7.20'],
		pn12_5: ['5.60', '6.00'],
		pn10: ['4.50', '4.80'],
		pn8: ['3.60', '3.90'],
		pn6: [null, null],
	},
	{
		minOd: 90,
		maxOd: '90.45',
		pn16: ['8.20', '8.80'],
		pn12_5: ['6.70', '7.10'],
		pn10: ['5.40', '5.80'],
		pn8: ['4.30', '4.60'],
		pn6: ['3.50', '3.80'],
	},
	{
		minOd: 110,
		maxOd: '110.45',
		pn16: ['10.00', '10.60'],
		pn12_5: ['8.10', '8.60'],
		pn10: ['6.60', '7.00'],
		pn8: ['5.30', '5.70'],
		pn6: ['4.20', '4.50'],
	},
	{
		minOd: 125,
		maxOd: '125.60',
		pn16: ['11.40', '12.00'],
		pn12_5: ['9.20', '9.75'],
		pn10: ['7.40', '7.80'],
		pn8: ['6.00', '6.40'],
		pn6: ['4.80', '5.10'],
	},
	{
		minOd: 140,
		maxOd: '140.70',
		pn16: ['12.70', '13.20'],
		pn12_5: ['10.30', '10.90'],
		pn10: ['8.30', '8.70'],
		pn8: ['6.70', '7.20'],
		pn6: ['5.40', '5.90'],
	},
	{
		minOd: 160,
		maxOd: '160.75',
		pn16: ['14.60', '15.40'],
		pn12_5: ['11.80', '12.45'],
		pn10: ['9.50', '10.00'],
		pn8: ['7.70', '8.15'],
		pn6: ['6.20', '6.60'],
	},
	{
		minOd: 180,
		maxOd: '180.80',
		pn16: ['16.40', '17.10'],
		pn12_5: ['13.30', '14.00'],
		pn10: ['10.70', '11.20'],
		pn8: ['8.60', '9.20'],
		pn6: ['6.90', '7.50'],
	},
	{
		minOd: 200,
		maxOd: '200.80',
		pn16: ['18.20', '19.20'],
		pn12_5: ['14.70', '15.50'],
		pn10: ['11.90', '12.50'],
		pn8: ['9.60', '10.15'],
		pn6: ['7.70', '8.20'],
	},
	{
		minOd: 225,
		maxOd: '226.00',
		pn16: ['20.50', '21.20'],
		pn12_5: ['16.60', '17.40'],
		pn10: ['13.40', '14.20'],
		pn8: ['10.80', '11.50'],
		pn6: ['8.60', '9.20'],
	},
	{
		minOd: 250,
		maxOd: '251.00',
		pn16: ['22.70', '23.90'],
		pn12_5: ['18.40', '19.40'],
		pn10: ['14.80', '15.60'],
		pn8: ['11.90', '12.55'],
		pn6: ['9.60', '10.20'],
	},
	{
		minOd: 280,
		maxOd: '281.00',
		pn16: ['25.40', '26.20'],
		pn12_5: ['20.60', '21.30'],
		pn10: ['16.60', '17.30'],
		pn8: ['13.40', '14.10'],
		pn6: ['10.70', '11.50'],
	},
	{
		minOd: 315,
		maxOd: '316.00',
		pn16: ['28.60', '30.10'],
		pn12_5: ['23.20', '24.45'],
		pn10: ['18.70', '19.70'],
		pn8: ['15.00', '15.80'],
		pn6: ['12.10', '12.80'],
	},
]

export const HDPE = () => {
	return (
		<div className='w-full overflow-x-auto rounded-2xl border border-brand-dark shadow-xl bg-white'>
			<table className='w-full min-w-[700px] border-collapse text-center font-sans text-xs'>
				<thead>
					{/* BRAND HEADER */}
					<tr className='bg-brand-dark text-white font-extrabold text-sm uppercase tracking-widest border-b border-slate-800'>
						<th colSpan={12} className='py-3 px-4'>
							AFRICA PIPETEK — HDPE PIPE WALL THICKNESS MATRIX
						</th>
					</tr>

					{/* UNIFORM PRESSURE RATINGS ROW */}
					<tr className='bg-slate-800 text-white font-bold border-b border-slate-700'>
						<th colSpan={2} className='border-r border-slate-700 py-2.5'>
							OD (mm)
						</th>
						<th colSpan={2} className='border-r border-slate-700 py-2.5'>
							PN16 MPa
						</th>
						<th colSpan={2} className='border-r border-slate-700 py-2.5'>
							PN12.5 MPa
						</th>
						<th colSpan={2} className='border-r border-slate-700 py-2.5'>
							PN10 MPa
						</th>
						<th colSpan={2} className='border-r border-slate-700 py-2.5'>
							PN8 MPa
						</th>
						<th colSpan={2} className='py-2.5'>
							PN6 MPa
						</th>
					</tr>

					{/* WALL THICKNESS SUB-HEADERS */}
					<tr className='bg-slate-100 text-slate-800 font-bold border-b border-slate-300 text-[10px]'>
						<th className='border-r border-slate-300 py-1.5 px-2'>MIN</th>
						<th className='border-r border-slate-300 py-1.5 px-2'>MAX</th>
						<th className='border-r border-slate-300 py-1.5 px-2'>MIN</th>
						<th className='border-r border-slate-300 py-1.5 px-2'>MAX</th>
						<th className='border-r border-slate-300 py-1.5 px-2'>MIN</th>
						<th className='border-r border-slate-300 py-1.5 px-2'>MAX</th>
						<th className='border-r border-slate-300 py-1.5 px-2'>MIN</th>
						<th className='border-r border-slate-300 py-1.5 px-2'>MAX</th>
						<th className='border-r border-slate-300 py-1.5 px-2'>MIN</th>
						<th className='border-r border-slate-300 py-1.5 px-2'>MAX</th>
						<th className='border-r border-slate-300 py-1.5 px-2'>MIN</th>
						<th className='py-1.5 px-2'>MAX</th>
					</tr>
				</thead>

				<tbody className='divide-y divide-slate-200 font-semibold text-slate-900 text-[11px] tabular-nums'>
					{hdpeMatrixData.map((row, i) => (
						<tr
							key={row.minOd}
							className={i % 2 === 0 ? 'bg-white' : 'bg-slate-50/70'}>
							<td className='bg-slate-100 border-r border-slate-300 py-1.5 px-2 font-extrabold text-brand-red'>
								{row.minOd}
							</td>
							<td className='border-r border-slate-200 py-1.5 px-2'>
								{row.maxOd}
							</td>
							<td className='border-r border-slate-200 py-1.5 px-2'>
								{row.pn16[0] ?? ''}
							</td>
							<td className='border-r border-slate-200 py-1.5 px-2'>
								{row.pn16[1] ?? ''}
							</td>
							<td className='border-r border-slate-200 py-1.5 px-2'>
								{row.pn12_5[0] ?? ''}
							</td>
							<td className='border-r border-slate-200 py-1.5 px-2'>
								{row.pn12_5[1] ?? ''}
							</td>
							<td className='border-r border-slate-200 py-1.5 px-2'>
								{row.pn10[0] ?? ''}
							</td>
							<td className='border-r border-slate-200 py-1.5 px-2'>
								{row.pn10[1] ?? ''}
							</td>
							<td className='border-r border-slate-200 py-1.5 px-2'>
								{row.pn8[0] ?? ''}
							</td>
							<td className='border-r border-slate-200 py-1.5 px-2'>
								{row.pn8[1] ?? ''}
							</td>
							<td className='border-r border-slate-200 py-1.5 px-2'>
								{row.pn6[0] ?? ''}
							</td>
							<td className='py-1.5 px-2'>{row.pn6[1] ?? ''}</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	)
}
